import { FC } from "react";
import { Styled } from "./styled";
import useVideo, { IProps } from "./hook";

const VideoLayout = (props: ReturnType<typeof useVideo>) => {
  return (
    <Styled>
      <video
        width="100%"
        height={"100%"}
        controlsList="nodownload"
        controls
        style={{ maxHeight: "calc(100% - 10px)" }}
        src={props.uri}
      ></video>
    </Styled>
  );
};

const Video: FC<IProps> = (props: IProps) => (
  <VideoLayout {...useVideo(props)} />
);

export default Video;
